import _ from 'lodash';

/**
 * intended to be used as a way to differentiate between the Form Designer/Page Designer/Screen Designer modes, to show/hide fields in module editors
 */
const designerTypes = {
  ENTRY_FORM:   'entryForm', //new form designer, when used inside an experience
  LIBRARY_FORM: 'libraryForm', //new form designer, when used in the global library assets
  FOOTER:       'footer', //new form designer, when used in the global library assets
  PAGE:         'page', //macro page designer
  SCREEN:       'screen', //micro screen designer
  PROMOTION:    'promotion', //micro promotion designer
};

designerTypes.ALL = _.values(designerTypes);

designerTypes.isLibraryFormDesigner = _.memoize(
  (designerType) => designerType === designerTypes.LIBRARY_FORM,
  (designerType) => `cache-${designerType}`
);

designerTypes.isEntryFormDesigner = _.memoize(
  (designerType) => designerType === designerTypes.ENTRY_FORM,
  (designerType) => `cache-${designerType}`
);

designerTypes.isPromotionDesigner = _.memoize(
  (designerType) => designerType === designerTypes.PROMOTION,
  (designerType) => `cache-${designerType}`
);

designerTypes.isFormDesigner = _.memoize(
  (designerType) =>
    designerTypes.isEntryFormDesigner(designerType) || designerTypes.isLibraryFormDesigner(designerType),
  (designerType) => `cache-${designerType}`
);

designerTypes.isScreenDesigner = _.memoize(
  (designerType) => designerType === designerTypes.SCREEN,
  (designerType) => `cache-${designerType}`
);

designerTypes.isPageDesigner = _.memoize(
  (designerType) => designerType === designerTypes.PAGE,
  (designerType) => `cache-${designerType}`
);

designerTypes.isFooterDesigner = _.memoize(
  (designerType) => designerType === designerTypes.FOOTER,
  (designerType) => `cache-${designerType}`
);

designerTypes.isScreenOrFooterDesigner = _.memoize(
  (designerType) => _.includes([designerTypes.FOOTER, designerTypes.SCREEN], designerType),
  (designerType) => `cache-${designerType}`
);

designerTypes.isScreenOrPromotionDesigner = _.memoize(
  (designerType) => _.includes([designerTypes.PROMOTION, designerTypes.SCREEN], designerType),
  (designerType) => `cache-${designerType}`
);

designerTypes.isScreenOrFooterOrPromotionDesigner = _.memoize(
  (designerType) => _.includes([designerTypes.FOOTER, designerTypes.SCREEN, designerTypes.PROMOTION], designerType),
  (designerType) => `cache-${designerType}`
);

designerTypes.isLayoutDesigner = _.memoize(
  (designerType) =>
    designerTypes.isFormDesigner(designerType) ||
    designerTypes.isScreenDesigner(designerType) ||
    designerTypes.isFooterDesigner(designerType) ||
    designerTypes.isPromotionDesigner(designerType),
  (designerType) => `cache-${designerType}`
);

export default designerTypes;
